import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { apiAction } from '../../store/generalSlice';
import { Link } from 'react-router-dom';
import { DataGrid } from '@mui/x-data-grid';
import Spinner from '../../layout/Spinner';

const IncomingWebhooks = () => {
  const dispatch = useDispatch();
  const { incomingWebhooks } = useSelector((state) => state.general);

  console.log({ incomingWebhooks });

  useEffect(() => {
    dispatch(
      apiAction({
        reduxField: 'incomingWebhooks',
        route: 'incomingWebhooks/getIncomingWebhooks',
      })
    );
  }, []);

  const columns = [
    {
      field: '_id',
      headerName: 'Webhook ID',
      width: 250,
      renderCell: (params) => <Link to={`/incomingWebhook/${params.value}`}>{params.value}</Link>,
    },
    {
      field: 'name',
      headerName: 'Name',
      width: 200,
    },
    {
      field: 'status',
      headerName: 'Status',
      width: 200,
    },
    {
      field: 'url',
      headerName: 'URL',
      width: 200,
    },
  ];

  return Array.isArray(incomingWebhooks) ? (
    <div className='container mt-4' data-aos='fade-up' data-aos-delay='200'>
      <div className='row d-flex justify-content-center'>
        <div className='col-lg-12 d-flex justify-content-center border-bottom' data-aos='fade-up' data-aos-delay='200'>
          <h1>Webhooks</h1>
        </div>
      </div>
      <div className='row d-flex justify-content-center mt-4 pt-lg-0'>
        <Link to='/CreateIncomingWebhook' className='btn btn-outline-dark'>
          Create a Webhook
        </Link>
      </div>
      <div className='row d-flex justify-content-center m-4'>
        <div style={{ height: 400, width: '100%' }}>
          <DataGrid
            rows={incomingWebhooks.map((wh) => ({ id: wh._id, ...wh }))}
            columns={columns}
            pageSize={5}
            rowsPerPageOptions={[5]}
          />
        </div>
      </div>
    </div>
  ) : (
    <Spinner />
  );
};

export default IncomingWebhooks;
